<template>
	<span class="svg-container">{{src}}</span>
</template>

<script>
const cache = new Map();
export default {
	props: {
		src: {
			type: String,
			required: true,
		},
	},
	mounted() {
		this.insertSVG();
	},
	updated() {
		this.insertSVG();
	},
	methods: {
		insertSVG() {
			const preloadedSVG = this.$store.state.assets.loader.getResult(this.src, true);

			if (preloadedSVG) {
				this.$el.innerHTML = preloadedSVG;
			} else {
				this.getSVG();
			}
		},
		// This is the only place we use the fetch API. This call
		// will only be made if for some reason we fail to preload an SVG and then try
		// to inline it. That _should_ never happen.  Regardless this method could be rewritten
		// to use vue-resource in order to remove the dependency on the fetch API.
		async getSVG() {
			if (!cache.has(this.src)) {
				try {
					cache.set(this.src, fetch(this.src).then(r => r.text()));
				} catch (e) {
					cache.delete(this.src);
				}
			}

			if (cache.has(this.src)) {
				this.$el.innerHTML = await cache.get(this.src);
			}
		},
	},
};
</script>

<style lang="scss">
	.svg-container {
		display: block;
		width: 100%;

		// hide any unloaded svg text
		font-size: 0;
	}

	svg {
		display: block;
		width: 100%;
	}

	.svg-container svg:not(:root) {
		overflow: visible;
	}

	.svg-bg svg {
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/Vector.vue